import mongoose from "mongoose";
import { z } from "zod";

const isValidId = (id) => mongoose.Types.ObjectId.isValid(id);

export const CareerSchema = z.object({
  job_title: z
    .string()
    .min(1, "Job title is required.")
    .transform((val) => val.trim()),

  job_subtitle: z
    .string()
    .min(1, "Job sub title is required.")
    .transform((val) => val.trim()),

  slug: z
    .string()
    .min(1, { message: "Slug is required." })
    .trim()
    .transform(
      (slug) =>
        slug
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, "") // Remove invalid characters
          .replace(/\s+/g, "-") // Replace spaces with hyphens
          .replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
          .replace(/^-|-$/g, "") // Remove leading or trailing hyphens
    )
    .refine((slug) => /^[a-z0-9-]+$/.test(slug), {
      message:
        "Slug must contain only lowercase letters, numbers, and hyphens.",
    }),

  job_description: z
    .string()
    .min(1, "Job description is required.")
    .transform((val) => val.trim()),

  order_number: z
    .string()
    .transform((val) => val.trim() || "1")
    .refine((val) => !isNaN(Number(val)) && Number.isInteger(Number(val)), {
      message: "Order number must be a valid number",
    })
    .refine((val) => Number(val) > 0, {
      message: "Order number must be greater than 0",
    }),

  meta_title: z
    .string()
    .transform((val) => val.trim())
    .optional(),

  meta_image: z
    .string()
    .nullable()
    .refine((value) => value === null || isValidId(value), {
      message: "Meta Image must be a valid ObjectId or null.",
    })
    .default(null),

  meta_keywords: z
    .string()
    .transform((val) => val.trim())
    .optional(),

  meta_description: z
    .string()
    .transform((val) => val.trim())
    .optional(),
});
